<app-home-logged-out *ngIf="!auth.isLoggedIn()"></app-home-logged-out>
<app-home-logged-in *ngIf="auth.isLoggedIn() && auth.user"></app-home-logged-in>
<page-load-header *ngIf="auth.isLoggedIn() && !auth.user"></page-load-header>
